module.exports = __webpack_public_path__ + "static/media/STRIDE-Logo.ed6f6ba3.png";